import { render, staticRenderFns } from "./StockviewFilters.vue?vue&type=template&id=63d15ff0&"
import script from "./StockviewFilters.vue?vue&type=script&lang=js&"
export * from "./StockviewFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports